import { render, staticRenderFns } from "./CTTEXPRESSOLabel1.vue?vue&type=template&id=4903a3b6&scoped=true"
import script from "./CTTEXPRESSOLabel1.vue?vue&type=script&lang=js"
export * from "./CTTEXPRESSOLabel1.vue?vue&type=script&lang=js"
import style0 from "./CTTEXPRESSOLabel1.vue?vue&type=style&index=0&id=4903a3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903a3b6",
  null
  
)

export default component.exports